import { IComponentLoader, IHostContext } from '../../registry.types';

export function createStaticComponentsLoaders<TComponentModel>({
  components,
  context,
}: {
  components: Record<string, TComponentModel> | null;
  context: IHostContext;
}) {
  if (!components) {
    return {};
  }
  const { statics } = context.manifest;

  const getAssets = (componentName: string) => {
    return context.manifest.components[componentName]
      ? context.manifest.components[componentName].assets
      : [];
  };

  const loaders: Record<string, IComponentLoader<TComponentModel, never>> = {};

  Object.keys(components).forEach(componentName => {
    const loader: IComponentLoader<TComponentModel, never> = () => {
      return Promise.resolve(components[componentName]);
    };

    loader.assets = getAssets(componentName);

    loader.isPartExist = () => {
      console.warn(
        `Registry Warning – "isPartExist" is not valid for "eager" registry. Probably there is redundant call.`,
      );

      return false;
    };

    loader.statics = {
      ...context.statics,
      ...statics[componentName],
    };

    loaders[componentName] = loader;
  });

  return loaders;
}
